<template>
    <div id="unpack_manage">
        <div class="apart-top flex-row ">
            <div class="flex-row t-p-l-22 cursor_1" @click.stop="toPage">
                <img class="back-img" :src="require('@/assets/image/icon_right.png')">
                <span class="apart-top-title">
                    返回
                </span>
            </div>
        </div>
        <main class="unpack_main">
            <div class="left">
                <p class="title">仿写记录列表</p>
                <div class="content" style="width: 100%;">
                    <div class="item_sub" v-for="(item, itemIndex) in list" :key="item.chapterId" v-if="isEmpty">
                        <div class="item_top" @click.stop="itemClick(itemIndex, item)">
                            <div class="item_top_left">
                                <p class="u-line-2">{{ item.title }}</p>
                                <p><span>{{ item.wordCount }}字</span><span>已仿写：{{ item.mimicCount }}次</span></p>
                            </div>
                            <i class="el-icon-arrow-right item_top_right cursor_1"
                                v-if="item.mimicCount && item.mimicCount > 0"
                                :class="item.open ? 'item_top_right_y' : 'item_top_right_x'"></i>
                        </div>
                        <div class="item_content" v-if="item.mimics"
                            :class="item.open ? 'item_content_open' : 'item_content_close'">
                            <div class="item_content_list" v-for="(subItem, index) in item.mimics" :key="subItem.id"
                                :class="curApartId === subItem.id ? 'selectBox ' : 'cursor_1'"
                                @click.stop="currClick(subItem)">
                                <div class="item_content_index">{{ ++index }}</div>
                                <div class="item_top_left">
                                    <p class="u-line-2">{{ subItem.title }}</p>
                                    <p><span>{{ subItem.length }}字</span><span style="color: #aaa;">{{
                                        subItem.mimicTime
                                            }}</span></p>
                                </div>
                                <i class="el-icon-delete item_del_icon cursor_1" @click.stop="delLog(subItem)"></i>
                            </div>
                        </div>
                    </div>
                    <div v-if="!isEmpty">
                        <el-empty description="暂无仿写记录"></el-empty>
                    </div>
                </div>
            </div>
            <div class="center t-m-l-20">
                <p class="title">原文内容</p>
                <div class="content" v-html="ywText" v-if="isEmpty"></div>
                <div v-if="!isEmpty">
                    <el-empty description="暂无仿写记录"></el-empty>
                </div>
            </div>
            <div class="right">
                <p class="title">仿写内容</p>
                <div class="content" v-html="fxText" v-if="isEmpty"></div>
                <div v-if="!isEmpty">
                    <el-empty description="暂无仿写记录"></el-empty>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
import apart from '@/api/apart';
import popup from '@/components/dongeb/popup.vue';
export default {
    components: {
        popup
    },
    data() {
        return {
            list: [],
            fxText: '',
            ywText: '',
            curApartId: '',
            isEmpty: true,
            queryParams: {
                apartId: '',
                // pageNum: 1,
                // pageSize: 10,
            }
        }
    },
    created() {
        let { apartId } = this.$route.query
        if (apartId) {
            this.queryParams.apartId = apartId
            this.init()
        }

    },
    methods: {
        init() {
            apart.apartLogList(this.queryParams).then(res => {
                if (res.code === 200) {
                    this.list = res.data && res.data.filter((f, i) => {
                        //初始化
                        if (i == 0) {
                            f.open = true
                            this.chapterLogList(i, f,'init')
                        } else {
                            f.open = false
                        }
                        return f
                    })
                    // console.log('this.list=', this.list)
                    this.isEmpty = this.list && this.list.length > 0 ? true : false
                }
            })
        },
        //仿写章节记录列表
        chapterLogList(i, item, isInit='') {
            apart.chapterLogList({ chapterId: item.chapterId }).then(res => {
                if (res.code === 200) {
                    item.mimics = res.data
                    if (isInit) {
                        if (item.mimics && item.mimics.length > 0) {
                            this.currClick(item.mimics[0])
                        }
                    }
                }
            })
        },
        toPage() {
            this.$router.go(-1)
        },
        currClick(mimics) {
            if (this.curApartId === mimics.id) return
            this.curApartId = mimics.id
            this.apartLogDetail(mimics.id)
        },
        itemClick(i, item) {
            item.open = !item.open
            if (item.open) {
                this.chapterLogList(i, item)
            }

        },
        apartLogDetail(id) {
            apart.apartLogDetail({ id }).then(res => {
                if (res.code === 200) {
                    this.fxText = res.data && res.data.result || ''
                    this.ywText = res.data && res.data.content || ''
                }
            })
        },
        delLog(mimics) {
            this.$confirm('确认删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                apart.mimicDel({ id: mimics.id }).then(res => {
                    if (res.code === 200) {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.init()
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        }
    }
}
</script>
<style lang="scss" scoped>
p,
h1,
dl,
dt,
dd {
    margin: 0;
    padding: 0;
}

::v-deep(.el-collapse) {
    border: 0;
}

.left,
.right,
.center {
    display: flex;
    flex-direction: column;
    font-family: Microsoft YaHei, Microsoft YaHei;
    overflow: auto;

    .title {
        height: 64px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-size: 18px;
        color: #0A0A0A;
        width: 100%;
        position: relative;
    }

    .content {
        overflow: auto;
        flex: 1;
        font-weight: 400;
        font-size: 15px;
        color: #222222;
        line-height: 22px;
        white-space: pre-wrap;
        /* 保留换行和空格 */
        @include no_scrollbar();
    }
}

.item_sub {

    .item_top,
    .item_content {
        position: relative;

        .item_top_left {
            p:first-child {
                font-size: 16px;
                font-weight: bold;
                margin-bottom: 10px;
            }

            p:last-child {
                font-size: 14px;
                display: flex;
                align-items: center;

                span:first-child {
                    color: #aaaaaa;

                    position: relative;

                    &::after {
                        content: '';
                        height: 60%;
                        width: 1px;
                        background-color: #aaaaaa;
                        position: absolute;
                        right: -0.5rem;
                        top: 20%;
                    }
                }

                span:last-child {
                    margin-left: 1rem;
                    color: var(--tech-primary);
                }
            }
        }


        .item_top_right {
            position: absolute;
            right: 15px;
        }

        .item_top_right_y {
            transition: transform 0.3s ease;
            transform: rotate(90deg);
        }

        .item_top_right_x {
            transition: transform 0.3s ease;
            transform: rotate(0deg);
            /* 旋转 90° */
        }
    }

    .item_top {
        display: flex;
        align-items: center;
        padding: 15px;
        margin: 0 15px;
        border-radius: 5px;
    }

    .item_content {
        background-color: #F2F6FC;
        display: none;
        padding: 10px 10px;
        margin: 0 15px;
        border-radius: 5px;

        .item_content_list {
            width: 100%;
            display: flex;
            align-items: center;
            padding: 5px 15px;
            // margin: 10px 0;
            margin-bottom: 15px;
            border-radius: 5px;
            box-sizing: border-box;
            position: relative;

            &:hover {
                outline: 1px solid var(--tech-btn-border);
                color: var(--tech-primary);
            }

            &:last-child {
                margin-bottom: 0;
            }

            .item_tools {
                position: absolute;
                height: 0;
                width: 100%;
                left: 0;
                background-color: rgba(0, 0, 0, .4);
                transform: all 0.3;

                &.item_tools_open {
                    height: 100%;
                }

                &.item_tools_close {
                    height: 0;
                }
            }

            .item_del_icon {
                position: absolute;
                right: 5px;
                bottom: 8px;
                color: #aaaaaa;

                &:hover {
                    color: var(--tech-primary);
                }
            }
        }

        .selectBox {
            outline: 1px solid var(--tech-btn-border);
            color: var(--tech-primary);
        }
        .cursor_1{
            cursor: pointer;
            opacity: 1;
        }

        .item_content_index {
            text-align: center;
            line-height: 20px;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background-color: color-mix(in srgb, var(--tech-primary) 20%, white);;
            color: var(--tech-primary);
            margin-right: 20px;
            flex-shrink: 0;
        }

        &.item_content_open {
            display: block !important;
            transition: all 0.3s ease;
        }

        &.item_content_close {
            display: none !important;
            transition: all 0.3s ease;
        }
    }
}

#unpack_manage {
    height: 100vh;
    width: 100vw;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;

    .apart-top {
        width: 100%;
        height: 64px;
        background: #FFFFFF;
        box-shadow: 0px 1px 8px 0px rgba(117, 53, 0, 0.12);
        border-radius: 0px 0px 0px 0px;

        .back-img {
            display: block;
            margin-top: 2px;
        }

        .apart-top-title {
            height: 16px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 16px;
            color: #333333;
            line-height: 16px;
            margin-left: 4px;
        }
    }

    .unpack_main {
        width: 100%;
        flex: 1;
        display: flex;
        box-sizing: border-box;
        position: relative;
        overflow: hidden;
        padding-top: 12px;

        .left {
            width: 350px;
            flex-shrink: 0;
            font-family: Microsoft YaHei, Microsoft YaHei;
            padding: 8px 0;
            background-color: #ffffff;
            box-shadow: 0px 0px 8px 0px rgba(117, 53, 0, 0.06);
            border-radius: 8px 0px 0px 0px;

            .title {
                &::before {
                    content: " ";
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    height: 1px;
                    width: 100%;
                    background-color: #E6EBF0;
                }
            }
        }

        .center {
            width: 50%;
            overflow: auto;
            padding: 8px 36px;
            font-family: Microsoft YaHei, Microsoft YaHei;
        }

        .right {
            width: 50%;
            padding: 8px 36px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            background-color: #ffffff;
            border-radius: 8px 8px 0px 0px;
            box-shadow: 0px 0px 8px 0px rgba(117, 53, 0, 0.06);
        }
    }
}

@keyframes sz {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(90deg);
    }
}
</style>